export default __webpack_public_path__ + "static/media/professional.dd53b79a.png";